<section class="empty-state stack" [class.empty-state--boxed]="isBoxed()" [class.state-box]="isBoxed()" [attr.aria-label]="heading()">
  @if (showsArt()) {
    <svg class="empty-state__art" width="160" height="120" viewBox="0 0 160 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="14" y="20" width="132" height="80" rx="10" fill="var(--surface-hover)" stroke="var(--border-subtle)" />
      <rect x="28" y="36" width="80" height="10" rx="5" fill="var(--border-subtle)" />
      <rect x="28" y="54" width="104" height="8" rx="4" fill="var(--surface-active)" />
      <rect x="28" y="68" width="92" height="8" rx="4" fill="var(--surface-active)" />
      <circle cx="124" cy="42" r="6" fill="var(--border-subtle)" />
      <circle cx="140" cy="42" r="6" fill="var(--border-subtle)" />
    </svg>
  }

  @let level = headingLevel();
  @switch (level) {
    @case (3) {
      <h3 class="empty-state__title heading-3 heading-flush">{{ heading() }}</h3>
    }
    @case (4) {
      <h4 class="empty-state__title heading-3 heading-flush">{{ heading() }}</h4>
    }
    @case (2) {
      <h2 class="empty-state__title heading-2 heading-flush">{{ heading() }}</h2>
    }
    @default never;
  }

  @if (subtitle(); as text) {
    <p class="empty-state__subtitle mat-font-body-md mat-text-on-surface-variant">{{ text }}</p>
  }

  <div class="empty-state__actions cluster">
    <ng-content />
  </div>
</section>
